import SavedAddresses from './SavedAddresses';

export default SavedAddresses;
